// `metadata.referenceId` dos modelos de dashboard do Domínio, copiados para cada empresa.
// O nome não serve para reconhecê-los: o escritório pode renomear o dashboard.
// Espelho dos modelos do back (`nucont-back-api/services/data-engine/src/_shared/data/dominio/`:
// `dashboards-tax-dominio.data.ts`, `dashboards-persoonel-dominio.data.ts`, o
// `DASHBOARD_DEPARTAMENTO_PESSOAL_ID` e o `DASHBOARD_PRO_LABORE_ID`). Modelo novo do Domínio no back
// precisa entrar aqui, ou a empresa não abre nele.
export const DOMINIO_DASHBOARD_REFERENCE_IDS = [
    // Fiscal
    "kqq7zxk4zaj4if3mr6zehh", // Domínio - Simples Nacional
    "4qdtnv2l80s7p5oadczbda", // Domínio - Período Simples Nacional
    "86cqhtuc8zeu6i8qz6n9n", // Domínio - Lucro
    "lu42ucddm6b9g281zyt5qf", // Domínio - Período
    "2at0gwqbgo2gjc9dc05z29", // Domínio - Guias do Mês
    "xxr8vsgmp69bem5zaa62fp", // Domínio - Carga Tributária
    "x71w71pwwpuh0x3jr4aysl", // Domínio - ICMS e ST
    // Pessoal
    "e3dm3pm6tf8gjzslko6wb", // Domínio - Padrão
    "8pcgu1xk919238gexb5cyr", // Domínio - Análise Vertical
    "ot29ijk8yiiik37gdlvc0j", // Domínio - Folha & Faturamento
    "eeiaca8sqdqbg3y758k5f", // Domínio - Departamento Pessoal
    "y6o8q43ccttj6a7121awy" // Domínio - Pró-Labore (empresa só com sócios na folha)
];
